import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import { topologyList } from "./topologyCountryList";

export function calulateTradesLast7Days(filteredOnCountryData: any) {
  type MyItem = {
    name: string;
    dateTimeSent: string; // or Date
    tradeID: string;
  };

  const now = new Date();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(now.getDate() - 6);

  const currentESIDs: string[] = [];

  const countLast7Days = filteredOnCountryData.reduce(
    (acc: number, item: MyItem) => {
      if (currentESIDs.includes(item.tradeID)) {
        return acc;
      }
      const itemDate = new Date(item.dateTimeSent);
      if (itemDate >= sevenDaysAgo && itemDate <= now) {
        currentESIDs.push(item.tradeID);
        return acc + 1;
      }
      return acc;
    },
    0,
  );

  return { countLast7Days, currentESIDs };
}

// );

//   return countLast7Days.length;
// }

// CONVERT dates
export function parseDDMMYYYY(dateStr: string): Date {
  const [day, month, year] = dateStr.split("/").map(Number);
  return new Date(year, month - 1, day); // month is 0-based
}

export function getTodayDDMMYYYY(): string {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // month is 0-based
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
}

export function getrandom7DayDDMMYYYY(): {
  year: number;
  month: string;
  day: string;
} {
  const today = new Date();
  const daysToSubtract = Math.floor(Math.random() * 7); // Random integer from 0 to 6
  const randomPastDay = new Date(today); // Create a copy of today's date
  randomPastDay.setDate(today.getDate() - daysToSubtract);
  const day = String(randomPastDay.getDate()).padStart(2, "0");
  const month = String(randomPastDay.getMonth() + 1).padStart(2, "0"); // month is 0-based
  const year = randomPastDay.getFullYear();
  return { year, month, day };
  // return `${year}-${month}-${day}T21:26:30.2630`;
}

function isSameDay(d1: Date, d2: Date): boolean {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

// const { range } = dataFilters;

// // If there's no valid range, return the original data
// if (!Array.isArray(range) || range.length !== 2) {
//   return data;
// }

// const startDate = new Date(range[0]);
// const endDate = new Date(range[1]);

// // Filter directly by returning the boolean expression
// return data.filter((obj) => {
//   const objDate = new Date(obj.dateTimeExecuted);
//   return objDate >= startDate && objDate <= endDate;
// });

// DATE FILTER
export function filterByDates(
  data: IBaseAnalyticsCombined[],
  dataFilters: any,
) {
  const { range } = dataFilters;
  const { activeDay } = dataFilters;

  if (activeDay) {
    const singleDates = data.filter((obj) => {
      const objDate = new Date(obj.dateTimeSent);
      const isMatch = isSameDay(objDate, activeDay);
      return isMatch;
    });
    return singleDates;
  }
  // If there's no valid range, return the original data
  if (!Array.isArray(range) || range.length !== 2) {
    return data;
  }

  const startDate = new Date(range[0]);
  const endDate = new Date(range[1]);

  // Filter directly by returning the boolean expression
  const finalObj = data.filter((obj) => {
    const objDate = new Date(obj.dateTimeSent);
    return objDate >= startDate && objDate <= endDate;
  });

  return finalObj;
}

// COUNTRY FILTER
export function filterByCountryName(data: any, dataFilters: any) {
  const { countryActive } = dataFilters;

  // If there's no valid range, return the original data
  if (!countryActive || countryActive == "") {
    return data;
  }

  return data.filter((obj: any) => {
    return obj.issueCountry == countryActive;
  });
}

//REDUCE COUNTRIES TO NAME LIST
export function listOfCountriesInArray(data: any) {
  return data.reduce((acc: any, item: any) => {
    if (!acc.includes(item.issueCountry)) {
      if (topologyList.includes(item.issueCountry)) {
        acc.push(item.issueCountry);
      }
    }
    return acc;
  }, [] as string[]);
}

// Reverse look up. Provide a date name and look up from there using the same logic as the last 7 day bar.
export function getDateForDay(day: string): Date | null {
  const daysOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri"];

  if (!daysOfWeek.includes(day)) return null;

  const now = new Date();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(now.getDate() - 7);

  // Find most recent occurrence of that day-of-week (Mon–Fri only)
  const targetIndex = daysOfWeek.indexOf(day) + 1; // 1=Mon … 5=Fri
  // const todayIndex = now.getDay(); // 0=Sun … 6=Sat

  // walk backwards from today until we find the match
  for (let i = 0; i < 7; i++) {
    const candidate = new Date(now);
    candidate.setDate(now.getDate() - i);
    if (candidate.getDay() === targetIndex) {
      if (candidate >= sevenDaysAgo) {
        return candidate;
      }
    }
  }

  return null; // not found in window
}
